export default[
    {
        name:"Company",
        path:"/About/Company",
        component:() => import("@/view/About/company"),
        meta:{
            title:"企业简介",
        }
    },
    {
        name:"Direction",
        path:"/About/Direction",
        component:() => import("@/view/About/direction"),
        meta:{
            title:"企业方向",
        }
    },
    {
        name:"Organizational",
        path:"/About/Organizational",
        component:() => import("@/view/About/organizational"),
        meta:{
            title:"组织架构",
        }
    },
    {
        name:"Rrecruit",
        path:"/About/Rrecruit",
        component:() => import("@/view/About/rrecruit"),
        meta:{
            title:"人才招聘",
        }
    }
]